
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import styled from "styled-components"
import Btn from "../../shared/button/Btn"
import { showModal } from "../../../features/modal/modalSlice"
import { useScrollLock } from "../../../hooks/useScrollLock"
import PageTopTitle from "../../shared/PageTopTitle"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import InputSelect from "../../shared/input/new/InputSelect"
import { teklifRed } from "../../../features/loadList/loadListSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import InputText from "../../shared/input/new/InputText"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1000px;
        height: auto;
        min-height: 450px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        max-height: 600px;
        overflow: auto;

        .content{
            margin: 40px;
            margin-bottom: 10px;
            padding: 30px;
            width: auto;
            display: flex;
            align-items: center;
            border-radius: 20px;
            gap: 40px;

        }

        .desc{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            color: var(--color-main);
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin: 30px 0;
            gap: 40px;
        }
    }
`
const options = [
    {
        id: 1,
        text: "Teklif fiyatı yüksek"
    },
    {
        id: 2,
        text: "Yük başkasına verildi"
    },
    {
        id: 3,
        text: "Sürücü yorumları iyi değil"
    },
    {
        id: 4,
        text: "Sürücü referansları yeterli değil"
    },
    {
        id: 5,
        text: "Araç uygun değil"
    },
    {
        id: 6,
        text: "Aracı beğenmedim"
    },
    {
        id: 7,
        text: "Nakliyeden vazgeçildi"
    },
    {
        id: 8,
        text: "Nakliye ertelendi"
    },
    {
        id: 9,
        text: "Diğer"
    }
]

const TeklifRejectReasonModal = () => {

    const location = useLocation()
    const dispatch = useDispatch()

    const {modalLocation } = useSelector(state => state.modal)
    const {loadItemSelect, isLoadingTeklifRed, selectedAspiredLoadId} = useSelector(state => state.loadList)
    const { lockScroll, unlockScroll } = useScrollLock();

    const [message, setMessage] = useState("")

    const [isSubmitted, setIsSubmited] = useState(false)

    const [teklifReason, setTeklifReason] = useState({
        id: "",
        text: ""
    })
    const [otherText, setOtherText] = useState("")
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const rld = JSON.parse(storage.getItem("rld"))
    
    const role = rld === "db7bb061-0f64-4eae-9c4f-678a7359fd01"|| rld === "f84f35ab-0eb1-46a4-84f4-e72b236c3d26" || rld === "a7b53ef7-1cf6-4720-9b13-d9f81b5a0f99"

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    useEffect(() => {
        if(isSubmitted){
            if(loadItemSelect.id && teklifReason.id && teklifReason.text){
                setMessage("")
            }
            else{
                setMessage("Lütfen ilgili alanları doldurun.")
            }
    }

    },[isSubmitted, loadItemSelect.id, teklifReason.id, teklifReason.text, otherText])
    
    const handleSubmit = () => {
        setIsSubmited(true)

        if(loadItemSelect.id && teklifReason.id && teklifReason.text){
            const data = {
                id: selectedAspiredLoadId,
                rejectReasonId: teklifReason.id,
                rejectReason: teklifReason.text,
                otherDesc: otherText,
                createdUserId: role ? loadItemSelect.createrUserId : ""
            }

            
            
            dispatch(teklifRed(data))
        }
    }


  return (
    <ModalContainer>
    <div className="modal" onClick={(e) => {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
        <PageTopTitle title={"Teklif Reddet"}/>
        <div className="content">
            <InputSelect data={teklifReason.text} setData={setTeklifReason} name={"teklifReason"} initialOptions={options} labelText={"Teklifi Reddetme Sebebi"} inputWidth={"300px"}/>
            {
                teklifReason?.id === 9 &&
                <InputText data={otherText} setData={(e) => setOtherText(e?.terget?.value)} labelText="Diğer" inputWidth={"300px"}/>
            }
        </div>
            {message && <p className="desc">{message}</p>}
        <div className='button-grp'>
            <Btn color={"#E85446"} bgColor={"transparent"} borderColor="#E85446" width="220px" radius={"10px"} handleClick={handleSubmit}>{isLoadingTeklifRed ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"} /> : "Gönder"}</Btn>
            <Btn color={"#E85446"} bgColor={"transparent"} borderColor="#E85446" width="220px" radius={"10px"} handleClick={()=> dispatch(showModal(null))}>Geri Dön</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default TeklifRejectReasonModal